import React, { useState, useEffect } from 'react'
import { css, StyleSheet } from 'aphrodite/no-important'
import { lowerCase } from 'lodash'

import { colors } from '@lmc/common/constants'
import { hexToRgbA } from '../../../common/utils'
import { OldButton } from '../../../components/generic'
import SingleCheckboxField from '../../../components/fields/types/SingleCheckboxField'
import { FamilyPaymentOption } from './components'
import { mixpanel } from '../../../common/services/analytics'
import { trackEvent } from '../../../common/services/intercom'
import { familyPriceTableMonthly } from '@lmc/common/constants/pricingTables'

const renderPaywallSectionHeader = (title) => (
  <h2 style={{ lineHeight: '36px', textAlign: 'center', margin: '0 auto' }}>
    {title}
  </h2>
)

const renderInviteBox = (openModal) => (
  <div style={styles.inviteBox}>
    <img
      alt=""
      src="https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/family/Family%26Friends+Icon+1.png"
      style={styles.familyLogo}
    />
    <h2 style={styles.inviteHeader}>Family Portal</h2>
    <div style={{ ...styles.inviteBoxMainText, marginBottom: 8 }}>
      The Family Portal is designed to help relatives keep in touch with their
      loved ones. This gives families <br />
      their own app, which provides them with access to their relatives’ care
      notes and records.
    </div>
    <div style={styles.inviteBoxMainText}>
      To start inviting families to the Family Portal, you'll need to set up the
      Family Portal add-on.
    </div>
    <div style={{ marginTop: 21 }}>
      <OldButton
        onClick={openModal}
        type="add"
        text="Set up Family Portal"
        style={styles.familySetupBtn}
      />
    </div>
    <div style={{ ...styles.mainTextBulletPoints, margin: '21px 0 31px 0' }}>
      Make sure you know: <br />
      • How you would like to personalise the apps <br />• Who the Family Portal
      will be billed to
    </div>
  </div>
)

// Benefits Section

const renderBenefitsItem = (iconUrl, description, key) => (
  <div style={styles.benefitsItem} key={key}>
    <img alt="" src={iconUrl} style={styles.benefitsItemIcon} />
    <div style={styles.benefitsItemDescription}>{description}</div>
  </div>
)

const renderBenefitsSection = () => {
  const benefitsFirstRowData = [
    {
      iconUrl:
        'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/best+1.png',
      description:
        'Demonstrate outstanding care, innovation and family involvement',
    },
    {
      iconUrl:
        'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/survey.png',
      description: 'Choose what data is shown to meet your own data compliance',
    },
    {
      iconUrl:
        'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/phone.png',
      description: 'Lower customer service requirements on key staff',
    },
  ]

  const benefitsSecondRowData = [
    {
      iconUrl:
        'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/meeting.png',
      description: 'Reduce need for face to face meetings and phone calls',
    },
    {
      iconUrl:
        'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/camera.png',
      description: 'Share happy moments with attached photos',
    },
    {
      iconUrl:
        'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/contact+1.png',
      description:
        'Help keep loved ones in touch with clients and give them peace of mind',
    },
  ]

  const sectionTitle = 'What are the benefits for care services?'

  return (
    <div style={styles.sectionContainer}>
      {renderPaywallSectionHeader(sectionTitle)}
      <div style={styles.benefitsRow}>
        {benefitsFirstRowData.map((item, index) =>
          renderBenefitsItem(item.iconUrl, item.description, index)
        )}
      </div>
      <div style={styles.benefitsRow}>
        {benefitsSecondRowData.map((item, index) =>
          renderBenefitsItem(item.iconUrl, item.description, index)
        )}
      </div>
      {/* <div style={styles.testimonialsBtnContainer}>
                <Button text={'Read testimonials'} type={'cancel'} className={css(classes.pinkBtn)}/>
            </div> */}
    </div>
  )
}

// Features Section

const TryItOutDiagram = () => {
  const logCategories = [
    {
      label: 'Activities & Social',
      values: { isChecked: true },
    },
    {
      label: 'Clinical Care',
      values: { isChecked: false },
    },
    {
      label: 'Handovers',
      values: { isChecked: false },
    },
    {
      label: 'Health Visit',
      values: { isChecked: true },
    },
    {
      label: 'Personal Care',
      values: { isChecked: false },
    },
  ]

  const [isChecked, setIsChecked] = useState(true)
  const imgUrl = isChecked
    ? 'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/family/foodon.png'
    : 'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/family/foodoff.png'

  return (
    <div style={styles.featuresTryItOutDiagram}>
      <div style={styles.tryItOutContainer}>
        <img
          alt=""
          src="https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/family/tryitout.png"
          style={styles.tryItOutImage}
        />
      </div>
      <div style={styles.logCategoryBtnsContainer}>
        <div>
          <SingleCheckboxField
            compact
            label="Food & Drink"
            formKey="foodAndDrink"
            values={{ foodAndDrink: isChecked }}
            onChange={(output) => {
              setIsChecked(output.value)
            }}
          />
        </div>
        {logCategories.map((category) => (
          <div style={styles.logCategoryBtn} key={category.label}>
            <SingleCheckboxField
              compact
              label={category.label}
              values={category.values}
              formKey="isChecked"
            />
          </div>
        ))}
        <div style={styles.logCategoryBtnsMask} />
      </div>
      <div style={styles.phoneImgContainer}>
        <img alt="" src={imgUrl} style={styles.phoneImg} />
      </div>
      <div style={styles.whatFamiliesSeeContainer}>
        <img
          alt=""
          src="https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/family/whatfamiliessee.png"
          style={styles.whatFamiliesSeeImage}
        />
      </div>
    </div>
  )
}

const renderFeaturesSection = (openModal, preferredPeopleNominative) => {
  const sectionTitle = `What features does it provide to the families of your ${lowerCase(
    preferredPeopleNominative
  )}?`
  return (
    <div
      style={{ ...styles.sectionContainer, ...styles.whiteSectionContainer }}
    >
      {renderPaywallSectionHeader(sectionTitle)}
      <div style={styles.mainText}>
        Families and friends can log in via their own app and see a snapshot of
        important care related tasks, food, activities and health visits
        recorded as a timeline. They’ll also be able to see what medications
        their loved one is currently taking and additional information that your
        front-line care team records using their “Family Update” log.
      </div>
      <div
        style={{
          marginTop: 32,
          fontSize: 18,
          lineHeight: '32px',
          textAlign: 'center',
        }}
      >
        You can choose which information should be shared with the family.{' '}
        <br />
        You can best personalise the App to fit your care service.
      </div>
      <TryItOutDiagram />
      <div style={styles.appPersonalisationBtnContainer}>
        <a href={APP_PERSONALISATION_LINK} target="_blank" rel="noreferrer">
          <OldButton
            className={css(classes.pinkBtn)}
            text="Learn more about App personalisation"
            type="cancel"
          />
        </a>
      </div>
      <div style={styles.featuresSetupBtn}>
        <OldButton
          onClick={openModal}
          type="add"
          text="Set up Family Portal"
          style={styles.familySetupBtn}
        />
      </div>
    </div>
  )
}

// Cost Section

const renderCostSection = (
  openModal,
  activeResidents,
  preferredPeopleNominative
) => {
  const sectionTitle = 'How much does the Family Portal cost?'

  // if (!activeResidents) { return null }

  return (
    <div style={styles.sectionContainer}>
      {renderPaywallSectionHeader(sectionTitle)}
      <div style={styles.paymentOptionsContainer}>
        <FamilyPaymentOption
          payee="Care Service billed monthly"
          costPerMonth={familyPriceTableMonthly[activeResidents]}
          activeResidents={activeResidents}
          imgUrl="https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/family/nursing-home-free-trial.png"
          mainText={`The price is based on the number of active ${lowerCase(
            preferredPeopleNominative
          )} in your service.`}
          bulletPoint1="Offer as a benefit to as many families as you like"
          bulletPoint2="Demonstrate outstanding innovation and family involvement"
          bulletPoint3="Families don’t need to pay"
          preferredPeopleNominative={lowerCase(preferredPeopleNominative)}
        />
      </div>
      <div style={styles.costLearnMoreBtn}>
        <a href={PRICING_HELP_LINK} target="_blank" rel="noreferrer">
          <OldButton
            text="Learn more about pricing"
            type="cancel"
            className={css(classes.pinkBtn)}
          />
        </a>
      </div>
      <div style={styles.costSetupBtn}>
        <OldButton
          onClick={openModal}
          type="add"
          text="Set up Family Portal"
          style={styles.familySetupBtn}
        />
      </div>
    </div>
  )
}

// Security section

const renderSecuritySection = (openModal) => {
  const sectionTitle = 'Secure & compliant from the outset'
  return (
    <div
      style={{ ...styles.sectionContainer, ...styles.whiteSectionContainer }}
    >
      {renderPaywallSectionHeader(sectionTitle)}
      <div style={styles.mainText}>
        We take data security very seriously as with the rest of our care
        system, the Family Portal is secured to NHS standards and GDPR
        compliant. However, we know this isn’t always enough, that’s why your
        Managers have full access over which Family Portal users can see
        information through the app, switching it on or off as required.
      </div>
      <div style={styles.securitySetupBtn}>
        <OldButton
          onClick={openModal}
          type="add"
          text="Set up Family Portal"
          style={styles.familySetupBtn}
        />
      </div>
      <div style={styles.mainTextBulletPoints}>
        Make sure you know <br />
        • How you would like to personalise the apps <br />• Who the Family
        Portal will be billed to
      </div>
    </div>
  )
}

export default function FamilyPortalPaywall(props) {
  const { activeResidents, openModal, preferredPeopleNominative } = props

  useEffect(() => {
    trackEvent('CO_family_view_paywall')
    mixpanel.track('CO_family_view_paywall')
  }, [])

  const openFamilyModal = () => {
    trackEvent('CO_family_open_modal')
    mixpanel.track('CO_family_open_modal')
    openModal()
  }

  return (
    <div style={styles.wrapper}>
      <div style={styles.maskLayer} />
      <div style={styles.mainContainer}>
        {renderInviteBox(openFamilyModal)}
        {renderBenefitsSection()}
        {renderFeaturesSection(openFamilyModal, preferredPeopleNominative)}
        {renderCostSection(
          openFamilyModal,
          activeResidents,
          preferredPeopleNominative
        )}
        {renderSecuritySection(openFamilyModal)}
      </div>
    </div>
  )
}

const APP_PERSONALISATION_LINK =
  'https://support.logmycare.co.uk/en/articles/4248185-how-can-i-customise-the-family-app'
const PRICING_HELP_LINK =
  'https://support.logmycare.co.uk/en/articles/4448809-how-much-does-the-family-app-cost'

const classes = StyleSheet.create({
  pinkBtn: {
    color: `${colors.pink} !important`,
    background: `${colors.white} !important`,
    border: `1px solid ${colors.pink} !important`,
    boxShadow: `0 0 8px ${hexToRgbA(colors.black, 0.2)}`,
    ':hover': {
      color: `${colors.pink} !important`,
      border: `1px solid ${colors.pink} !important`,
      boxShadow: `0 0 8px ${hexToRgbA(colors.black, 0.2)} !important`,
    },
  },
})

const styles = {
  appPersonalisationBtnContainer: {
    marginTop: 28,
    display: 'flex',
    justifyContent: 'center',
  },
  benefitsItem: {
    width: 235,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    margin: '0 40px 0 40px',
  },
  benefitsItemIcon: {
    height: 84,
  },
  benefitsItemDescription: {
    lineHeight: '22px',
    marginTop: 16,
    textAlign: 'center',
  },
  benefitsRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 40,
  },
  costBulletPoints: {
    paddingLeft: 20,
    margin: 0,
  },
  costImage: {
    height: 140,
  },
  costImageContainer: {
    margin: '28px 0 32px 0',
  },
  costLearnMoreBtn: {
    padding: '50px 0 16px 0',
    display: 'flex',
    justifyContent: 'center',
  },
  costOptionSectionContainer: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
  },
  costOptionTitle: {
    fontSize: 18,
    lineHeight: '32px',
    color: colors.pink,
    textAlign: 'center',
    paddingBottom: 8,
  },
  costMainText: {
    fontSize: 14,
    lineHeight: '22px',
    textAlign: 'center',
  },
  costSetupBtn: {
    display: 'flex',
    justifyContent: 'center',
  },
  familyLogo: {
    height: 63,
    marginTop: 22,
    marginBottom: 17,
  },
  familySetupBtn: {
    height: 40,
    boxShadow: `0 0 8px ${hexToRgbA(colors.black, 0.2)}`,
  },
  featuresSetupBtn: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 16,
  },
  featuresTryItOutDiagram: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 24,
  },
  greyLine: {
    height: 1,
    background: colors.grey,
    width: '100%',
  },
  inviteBox: {
    alignItems: 'center',
    background: colors.white,
    borderRadius: 4,
    border: `1px solid ${colors.grey}`,
    display: 'flex',
    flexDirection: 'column',
  },
  inviteBoxBulletPoints: {
    marginTop: 21,
    textAlign: 'center',
    lineHeight: '18px',
    fontSize: 12,
    marginBottom: 31,
  },
  inviteBoxMainText: {
    lineHeight: '22px',
    textAlign: 'center',
  },
  inviteHeader: {
    lineHeight: '36px',
    marginBottom: 15,
  },
  logCategoryBtn: {
    marginTop: 10,
  },
  logCategoryBtnsContainer: {
    marginTop: 20,
    marginRight: 17.5,
    maxHeight: 400,
  },
  logCategoryBtnsMask: {
    background: `linear-gradient(${hexToRgbA(colors.white, 0.7)}, ${
      colors.white
    })`,
    height: 280,
    position: 'relative',
    top: -235,
  },
  mainContainer: {
    background: colors.background,
    height: '100%',
  },
  mainText: {
    lineHeight: '22px',
    marginTop: 16,
    textAlign: 'center',
  },
  mainTextBulletPoints: {
    fontSize: 12,
    lineHeight: '18px',
    textAlign: 'center',
  },
  maskLayer: {
    height: 185,
    background: colors.background,
    opacity: 0.8,
  },
  monthlyCostContainer: {
    padding: '24px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  monthlyCostSubtitle: {
    color: colors.darkgrey,
    marginTop: 8,
    lineHeight: '18px',
    fontSize: 12,
  },
  monthlyCostTitle: {
    fontSize: 18,
    lineHeight: '32px',
    fontWeight: 'bold',
  },
  payeeOptionTitle: {
    fontSize: 18,
    lineHeight: '32px',
    padding: '16px 0 16px 0',
  },
  paymentOptionsContainer: {
    marginTop: 32,
    display: 'flex',
    justifyContent: 'center',
  },
  phoneImg: {
    width: 224,
  },
  phoneImgContainer: {
    marginLeft: 17.5,
  },
  sectionContainer: {
    paddingTop: 64,
    paddingBottom: 64,
  },
  sectionHeaderLine: {
    background: colors.orange,
    marginTop: 8,
  },
  securitySetupBtn: {
    padding: '40px 0 8px 0',
    display: 'flex',
    justifyContent: 'center',
  },
  testimonialsBtnContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 40,
    height: 40,
  },
  tryItOutContainer: {
    position: 'relative',
    left: -18.5,
    top: 33,
  },
  tryItOutImage: {
    width: 89,
  },
  whatFamiliesSeeContainer: {
    position: 'relative',
    left: 20,
    top: 147,
  },
  whatFamiliesSeeImage: {
    width: 106,
  },
  whiteSectionContainer: {
    // These margins come from the max-width of the container, plus its
    // padding/margin. It was a faff to sort them!
    marginLeft: 'min(-50vw + 540px - 24px, -24px)',
    paddingLeft: 'max(50vw - 540px + 24px, 24px)',
    marginRight: 'min(-50vw + 540px - 24px, -24px)',
    paddingRight: 'max(50vw - 540px + 24px, 24px)',
    background: colors.white,
  },
  wrapper: {
    position: 'relative',
    top: -140,
    width: '100%',
    height: '100%',
    maxWidth: 1080,
    marginBottom: '-370px',
  },
}
